import { createSelector } from '@ngrx/store';

import { homeState } from './home.selectors';

const changePasswordState = createSelector(homeState, (state) => state.changePassword);

export const isChangePasswordLoading = createSelector(changePasswordState, (state) => state.isLoading);
export const isChangePasswordSuccess = createSelector(changePasswordState, (state) => state.isChangedSuccessfully);
export const changePasswordErrorMsg = createSelector(changePasswordState, (state) => state?.error?.text);
